import React from "react";
import Link from "next/link";
import { BiBrain, BiTrendingUp, BiShield, BiTargetLock, BiCog } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const KiAdvantages = () => {
  const { t } = useTranslations();
  const advantages = [
    {
      icon: BiCog,
      title: t("ki_advantages_title1"),
      description: t("ki_advantages_description1"),
      color: "linear-gradient(135deg, #59bd65 0%, #4CAF50 100%)"
    },
    {
      icon: BiBrain,
      title: t("ki_advantages_title2"),
      description: t("ki_advantages_description2"),
      color: "linear-gradient(135deg, #4CAF50 0%, #59bd65 50%, #2e7d32 100%)"
    },
    {
      icon: BiTrendingUp,
      title: t("ki_advantages_title3"),
      description: t("ki_advantages_description3"),
      color: "linear-gradient(135deg, #59bd65 0%, #66bb6a 30%, #2e7d32 100%)"
    },
    {
      icon: BiTargetLock,
      title: t("ki_advantages_title4"),
      description: t("ki_advantages_description4"),
      color: "linear-gradient(135deg, #388e3c 0%, #59bd65 50%, #66bb6a 100%)"
    },
    {
      icon: BiShield,
      title: t("ki_advantages_title5"),
      description: t("ki_advantages_description5"),
      color: "linear-gradient(135deg, #4CAF50 0%, #59bd65 40%, #388e3c 100%)"
    }
  ];

  return (
    <section className="services-area pt-100 pb-100 ki-advantages-section">
      {/* Hintergrund-Dekoration */}
      <div className="bg-decoration bg-decoration-1"></div>
      <div className="bg-decoration bg-decoration-2"></div>

      <div className="container">
        <div className="row align-items-stretch">
          <div className="col-lg-6 ki-first-card">
            <div className="content left-content ki-content-card">
              {/* Header */}
              <div className="text-center mb-5 ki-header">
                <span className="ki-badge">
                  {t("ki_advantages_title")}
                </span>
                <h2 className="ki-title">
                  {t("ki_advantages_title_second")}
                </h2>
                <p className="ki-description">
                  {t("ki_advantages_description")}
                </p>
              </div>

              {/* Advantages List */}
              <div className="advantages-list">
                {advantages.map((advantage, index) => {
                  const IconComponent = advantage.icon;
                  return (
                    <div
                      key={index}
                      className="advantage-item"
                      data-aos="fade-up"
                      data-aos-delay={100 + (index * 50)}
                      data-aos-duration="1200"
                    >
                      {/* Icon */}
                      <div
                        className="advantage-icon"
                        style={{ background: advantage.color }}
                      >
                        <IconComponent className="advantage-icon-svg" />
                      </div>

                      {/* Content */}
                      <div>
                        <h4 className="advantage-title">
                          {advantage.title}
                        </h4>
                        <p className="advantage-text">
                          {advantage.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* CTA Button */}
              <div className="text-center mt-auto ki-cta-container">
                <Link href="/kontakt" className="ki-cta-button">
                  {t("ki_advantages_cta_button")}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="content right-content ki-content-card">
              {/* Header */}
              <div className="text-center mb-5 ki-header">
                <span className="ki-badge">
                  {t("ki_advantages_title_third")}
                </span>
                <h2 className="ki-title">
                  {t("ki_advantages_title_third2")}
                </h2>
                <p className="ki-description">
                  {t("ki_advantages_description_third")}
                </p>
              </div>

              {/* Technologies List */}
              <div className="technologies-list">
                {[
                  {
                    icon: BiBrain,
                    title: t("ki_advantages_title_third3"),
                    description: t("ki_advantages_description_third3"),
                    color: "linear-gradient(135deg, #59bd65 0%, #2e7d32 100%)"
                  },
                  {
                    icon: BiTargetLock,
                    title: t("ki_advantages_title_third4"),
                    description: t("ki_advantages_description_third4"),
                    color: "linear-gradient(135deg, #4CAF50 0%, #59bd65 30%, #2e7d32 100%)"
                  },
                  {
                    icon: BiTrendingUp,
                    title: t("ki_advantages_title_third5"),
                    description: t("ki_advantages_description_third5"),
                    color: "linear-gradient(135deg, #59bd65 0%, #66bb6a 30%, #2e7d32 100%)"
                  },
                  {
                    icon: BiShield,
                    title: t("ki_advantages_title_third6"),
                    description: t("ki_advantages_description_third6"),
                    color: "linear-gradient(135deg, #388e3c 0%, #59bd65 50%, #66bb6a 100%)"
                  },
                  {
                    icon: BiCog,
                    title: t("ki_advantages_title_third7"),
                    description: t("ki_advantages_description_third7"),
                    color: "linear-gradient(135deg, #4CAF50 0%, #59bd65 40%, #388e3c 100%)"
                  }
                ].map((technology, index) => {
                  const IconComponent = technology.icon;
                  return (
                    <div
                      key={index}
                      className="technology-item"
                      data-aos="fade-up"
                      data-aos-delay={100 + (index * 50)}
                      data-aos-duration="1200"
                    >
                      {/* Icon */}
                      <div
                        className="technology-icon"
                        style={{ background: technology.color }}
                      >
                        <IconComponent className="technology-icon-svg" />
                      </div>

                      {/* Content */}
                      <div>
                        <h4 className="technology-title">
                          {technology.title}
                        </h4>
                        <p className="technology-text">
                          {technology.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* CTA Button */}
              <div className="text-center mt-auto ki-cta-container">
                <Link href="/kontakt" className="ki-cta-button">
                  {t("ki_advantages_cta_button2")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KiAdvantages;
